<ng-container *ngIf="quickquote$ | async as quickquote">
  <div class="beat-your-broker__card" *ngIf="!quickquote">
    Questionnaire {{name}} not found
  </div>

  <ng-container *ngIf="quickquote">
    <div class="beat-your-broker__card" *ngIf="page$ | async as page" [appScrollIntoView]="page" 
    [ngClass]="page.type === 'BeatYourBrokerResult' ? 'wide' : null">
      <div class="title">{{quickquote.header}}</div>
      <div class="beat-your-broker__body" [ngSwitch]="page.type">
        <app-apg-beat-your-broker-page *ngSwitchDefault [page]="page" [firstPage]="page.index === 0"
                                        (opened)="open($event)">
        </app-apg-beat-your-broker-page>

        <app-apg-quick-quote-otp *ngSwitchCase="'Otp'" [quickQuote]="quickquote" [action]="'sendViaSms'"
                                  [otpContentKey]="'BeatYourBrokerOtp'" (next)="saveOtp(quickquote, page, $event.code)"
                                  (back)="navigateBack(quickquote, page, 1)">
        </app-apg-quick-quote-otp>

        <app-apg-beat-your-broker-result *ngSwitchCase="'BeatYourBrokerResult'" [quickQuote]="quickquote"
                                          (back)="navigateBack(quickquote, page, 4)"
                                          (continue)="saveContactDate(quickquote, page, $event.date)">
        </app-apg-beat-your-broker-result>

        <app-apg-beat-your-broker-complete *ngSwitchCase="'Complete'" [quickQuote]="quickquote">
        </app-apg-beat-your-broker-complete>
      </div>
    </div>
  </ng-container>
</ng-container>